"use strict";
(function () {
    let validState = true;
    document.addEventListener('DOMContentLoaded', function () {
        const sliderContainer = document.querySelector('.ContentSlider');
        const slider = new Slider(sliderContainer.querySelector('.Slider'));
        // next
        sliderContainer.querySelector(".button--next").addEventListener('click', function () {
            const age = parseFloat(document.getElementById('calculator_age').value);
            const weight = parseFloat(document.getElementById('calculator_weight').value);
            const sleep = parseFloat(document.getElementById('calculator_sleep').value);
            const height = parseFloat(document.getElementById('calculator_height').value);
            const work = parseFloat(document.getElementById('calculator_work').value);
            switch (slider.slides[slider.currentIndex].getAttribute('data-calculator-step')) {
                case 'start':
                    document.querySelector(".button--prev").classList.remove("none");
                    slider.next();
                    break;
                case 'body':
                    let valid = true;
                    if (!(age > 0)) {
                        valid = false;
                        document.getElementById('calculator_age').classList.add("invalid");
                    }
                    else {
                        document.getElementById('calculator_age').classList.remove("invalid");
                    }
                    if (!(weight > 0)) {
                        valid = false;
                        document.getElementById('calculator_weight').classList.add("invalid");
                    }
                    else {
                        document.getElementById('calculator_weight').classList.remove("invalid");
                    }
                    if (!(height > 0)) {
                        valid = false;
                        document.getElementById('calculator_height').classList.add("invalid");
                    }
                    else {
                        document.getElementById('calculator_height').classList.remove("invalid");
                    }
                    if (valid) {
                        slider.next();
                    }
                    break;
                case 'sleep':
                    if (!(sleep > 0)) {
                        document.getElementById('calculator_sleep').classList.add("invalid");
                    }
                    else {
                        document.getElementById('calculator_sleep').classList.remove("invalid");
                        slider.next();
                    }
                    break;
                case 'work':
                    if (isNaN(work)) {
                        document.getElementById('calculator_work').classList.add("invalid");
                    }
                    else {
                        document.getElementById('calculator_work').classList.remove("invalid");
                        slider.next();
                    }
                    break;
                case 'everyday':
                    calculateCalories();
                    document.querySelector(".button--next").classList.add("none");
                    document.querySelector("#resultCollapse").classList.remove("none");
                    slider.next();
                    break;
                default:
                    slider.next();
            }
        }, false);
        // prev
        sliderContainer.querySelector(".button--prev").addEventListener('click', function () {
            switch (slider.slides[slider.currentIndex].getAttribute('data-calculator-step')) {
                case 'result':
                    document.querySelector(".button--next").classList.remove("none");
                    document.querySelector("#resultCollapse").classList.add("none");
                    slider.prev();
                    break;
                case 'intro':
                    document.querySelector(".button--prev").classList.add("none");
                    slider.prev();
                    break;
                default:
                    if (slider.currentIndex > 0) {
                        slider.prev();
                    }
            }
        }, false);
        // Validation
        sliderContainer.querySelectorAll('input').forEach(input => {
            input.addEventListener('change', validateInput);
            input.addEventListener('keyup', (e) => {
                if (validState)
                    return; // Only use this listener to remove error hints when the number is changed to legal
                validateInput(e);
            });
        });
        // Prevent switching to inputs on next slide
        sliderContainer.querySelectorAll('input').forEach(input => {
            input.addEventListener('keydown', (e) => {
                const target = e.target;
                if (e.key === 'Tab') {
                    const inputsOnSlide = target.closest('[data-calculator-step]').querySelectorAll('input');
                    if (inputsOnSlide.length === 0)
                        return;
                    if ((e.shiftKey && e.target === inputsOnSlide[0]) || (!e.shiftKey && e.target === inputsOnSlide[inputsOnSlide.length - 1]))
                        e.preventDefault();
                }
            });
        });
    });
    // Used to guarantee entered hours are possible
    function validateInput(e) {
        const target = e.target;
        if (!target || !target.id)
            return;
        const sliderContainer = document.querySelector('.ContentSlider');
        const errorMessageElement = sliderContainer.querySelector('[data-calculator-hint="too-many-hours"]');
        const hourPerDayInputs = ['sleep', 'work'];
        const hourPerWeekInputs = ['sport_low', 'sport_medium', 'sport_high', 'sport_extreme', 'everyday_low', 'everyday_medium'];
        let hoursSum = 0;
        hourPerDayInputs.forEach(id => {
            const hours = parseFloat(document.getElementById(`calculator_${id}`).value) || 0;
            hoursSum += hours;
        });
        hourPerWeekInputs.forEach(id => {
            const hours = parseFloat((document.getElementById(`calculator_${id}`).value)) || 0;
            hoursSum += hours / 7;
        });
        if (hoursSum > 24) {
            if (target.value != "0") {
                target.classList.add("invalid");
            }
            else {
                target.classList.remove("invalid");
            }
            if (errorMessageElement)
                errorMessageElement.classList.remove('none');
            sliderContainer.querySelector(".button--prev").disabled = true;
            sliderContainer.querySelector(".button--next").disabled = true;
            validState = false;
        }
        else {
            target.classList.remove("invalid");
            if (errorMessageElement)
                errorMessageElement.classList.add('none');
            sliderContainer.querySelector(".button--prev").disabled = false;
            sliderContainer.querySelector(".button--next").disabled = false;
            validState = true;
        }
    }
    function calculateCalories() {
        const weight = parseFloat(document.getElementById('calculator_weight').value);
        const height = parseFloat(document.getElementById('calculator_height').value);
        const age = parseFloat(document.getElementById('calculator_age').value);
        const sleep = parseFloat(document.getElementById('calculator_sleep').value);
        const work_hours = parseFloat(document.getElementById('calculator_work').value);
        let sport_low = parseFloat(document.getElementById('calculator_sport_low').value);
        let sport_medium = parseFloat(document.getElementById('calculator_sport_medium').value);
        let sport_high = parseFloat(document.getElementById('calculator_sport_high').value);
        let sport_extreme = parseFloat(document.getElementById('calculator_sport_extreme').value);
        let everyday_low = parseFloat(document.getElementById('calculator_everyday_low').value);
        let everyday_medium = parseFloat(document.getElementById('calculator_everyday_medium').value);
        // Check which select Field was selected
        const gender_radios = document.getElementsByName('gender');
        let gender = "";
        for (let i = 0, length = gender_radios.length; i < length; i++) {
            if (gender_radios[i].checked) {
                gender = gender_radios[i].value;
            }
        }
        // Check which select Field was selected
        const work_radios = document.getElementsByName('work');
        let work = "";
        for (let i = 0, length = work_radios.length; i < length; i++) {
            if (work_radios[i].checked) {
                work = work_radios[i].value;
            }
        }
        let work_pal = 0;
        switch (work) {
            case "low":
                work_pal = 1.45;
                break;
            case "medium":
                work_pal = 1.65;
                break;
            case "high":
                work_pal = 1.85;
                break;
            case "hard":
                work_pal = 2.2;
                break;
        }
        // Grundumsatz
        let calories = 0;
        if (gender == "Männlich") {
            calories = 66.47 + (13.7 * weight) + (5 * height) - (6.8 * age);
        }
        else {
            calories = 655.1 + (9.6 * weight) + (1.8 * height) - (4.7 * age);
        }
        console.log("Grundumsatz", calories);
        // Sleep
        const pal_sleep = 0.95 * sleep;
        // Work
        const pal_work = work_hours * work_pal;
        // Sport
        if (isNaN(sport_low))
            sport_low = 0;
        if (isNaN(sport_medium))
            sport_medium = 0;
        if (isNaN(sport_high))
            sport_high = 0;
        if (isNaN(sport_extreme))
            sport_extreme = 0;
        if (isNaN(everyday_low))
            everyday_low = 0;
        if (isNaN(everyday_medium))
            everyday_medium = 0;
        const met_sport = (2.5 * sport_low + 5 * sport_medium + 7 * sport_high + 10 * sport_extreme + 2.5 * everyday_low + 5 * everyday_medium) / 7;
        const hoursSum = sleep + work_hours + (sport_low + sport_medium + sport_high + sport_extreme + everyday_low + everyday_medium) / 7;
        const pal_rest = (24 - hoursSum) * 1.5;
        const met_daily = (met_sport + pal_work + pal_sleep + pal_rest) / 24;
        console.log(pal_sleep, pal_work, met_sport, met_daily, calories);
        console.log(hoursSum);
        calories += calories * (met_daily - 1);
        document.getElementById('result').textContent = `${Math.round(calories)}`;
        //Calculate Zone to lose weight
        const low = calories * 0.9;
        const high = calories * 0.95;
        document.getElementById('result_optimal').textContent = Math.round(low) + "-" + Math.round(high);
    }
})();
